import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { AppComponent } from '../app.component';
import { ProfileService } from '../services/profile.service';
import { SubMenuOption } from '../types/submenu-option';

@Component({
  selector: 'admin-sub-menu',
  template: `<sub-menu [options]="subMenu"></sub-menu>`,
})


export class AdminSubMenuComponent implements OnInit {
  CanAdminister = ProfileService.CanAdminister;
  subMenu = <SubMenuOption[]>[];
  hubID: number;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
  ) {
  }

  ngOnInit(): void {
    if (!AppComponent.IsLoggedIn()) { return; }
    this.subMenu = <SubMenuOption[]>[
      {route: `/admin/profiles`, title: 'Profiles'},
      {route: `/admin/configuration`, title: 'Config'},
      {route: `/admin/queries`, title: 'Queries'},
    ];
  }

}
